import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {toast} from '../util/toast';
import {Usuario} from '../models/usuario.model';
import {Config} from '@ionic/angular';
import {map} from 'rxjs/operators';
import {AbstractService} from './abstract.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService extends AbstractService {

  constructor(public http: HttpClient) {
    super('v1/usuario', http);
  }

  recuperarSenha(cpf: string) {
    return this.http.post<Config>(`${environment.apiUrl}/v1/usuario/recuperarSenha`, {cpf: cpf.replace(/[^0-9]+/g, '')})
      .pipe(map(
        (response: any) => {
          if (response instanceof HttpResponse) {
            toast(response);
          }
          return response;
        }
        )
      );
  }

  cadastrar(usuario: Usuario) {
    return this.http.put<Config>(`${environment.apiUrl}/v1/usuario`, usuario);
  }

  atualizar(usuario: Usuario) {
    return this.http.put<Config>(`${environment.apiUrl}/v1/usuario/atualizarUsuario`, usuario);
  }

  atualizarPorGN(usuario: Usuario) {
    return this.http.put<Config>(`${environment.apiUrl}/v1/usuario/atualizar`, usuario);
  }

  aprovar(username, motivoRecusa) {
    return this.post({motivoRecusa, username}, `aprovar`);
  }

  recusar(username, motivoRecusa) {
    return this.post({motivoRecusa, username}, `recusar`);
  }

  mudarSenha(senhaAtual: string, senhaNova: string) {
    return this.post({oldPassword: senhaAtual, newPassword: senhaNova}, `mudarSenha`);
  }

  redefinirSenha(hash: string, password: string) {
    return this.post({hash, password}, `redefinirSenha`);
  }

  convidarUsuario(email: string, codPerfil: string) {
    return this.post({email, codPerfil}, `convidarUsuario`);
  }

  async getPerfil(idUsuario: number): Promise<any> {
    return this.getById(idUsuario).toPromise();
  }

  getUsuario(usuarioId) {
    return this.http.get(`${environment.apiUrl}/v1/usuario/` + usuarioId);
  }

  getUsuarios(page: number, size: number, filter: any, nome: string) {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('size', size.toString());
    if (filter.uf && filter.uf != 'Todos') {
      params = params.set('uf', filter.uf.toString());
    }
    if (filter.municipio) {
      params = params.set('idMunicipio', filter.municipio.toString());
    }
    if (filter.situacao && filter.situacao != 'Todos') {
      params = params.set('idSituacao', filter.situacao.toString());
    }
    if (filter.perfil && filter.perfil != 'Todos') {
      params = params.set('idPerfil', filter.perfil.toString());
    }
    if (nome) {
      params = params.set('nomeUsuario', nome);
    }
    return this.filterByParam(params, 'buscarUsuarios');
  }

  getPerfis() {
    return this.http.get(`${environment.apiUrl}/v1/usuario/perfis`);
  }

}
